import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { B2CShikumLogo } from 'Images';

export const Logo = () => {
  return (
    <Stack alignItems='center' gap='4px' mb='48px'>
      <Avatar alt='' src={B2CShikumLogo} />
      <Typography variant='body1'>
        {Dictionary[DICTIONARY.B2C].Landing.logoTitle}
      </Typography>
    </Stack>
  );
};
